//CRN_20260508 - Riskline Alerts v4.1 PUSH API
//             - Frontend reads from SureSim backend (which receives Riskline POST/PUT/DELETE webhooks)
//             - Live updates via SignalR

import { RisklineMetaDTO } from './riskline-meta.dto';

//#region Nested collections

//CRN_20260511 - AreaType is an open string discriminator from vendor (country|region|city|airport|offshore|geojson|...).
export interface AlertImpactedAreaDTO {
  alertID     : string | null;
  areaType    : string | null;
  code        : string | null;
  id          : string | null;
  latitude    : number | null;
  longitude   : number | null;
  name        : string | null;
  radiusMeters: number | null;
}

//CRN_20260511 - RelationType is a string enum: 'country'|'region'|'city'|'airport'.
export interface AlertRelationDTO {
  alertID     : string | null;
  code        : string | null;
  id          : string | null;
  name        : string | null;
  relationType: string | null;
}

//#endregion

//#region Alert root + envelope

//CRN_20260511 - Backend maps vendor enum to bool: "past" -> false, "now"|"future" -> true. null when omitted.
export type AlertTakesPlaceDTO = boolean | null;

export interface AlertDTO {
  advice         : string | null;
  categoryID     : number | null;
  deleted        : boolean | null;
  endDate        : string | null;
  id             : string;
  impactedAreas  : AlertImpactedAreaDTO[];
  isActive       : boolean | null;
  isPublished    : boolean | null;
  lastUpdatedUtc : string | null;
  rawJson        : string | null;
  receivedUtc    : string | null;
  relations      : AlertRelationDTO[];
  riskLevelID    : number | null;
  startDate      : string | null;
  takesPlace     : AlertTakesPlaceDTO;
  text           : string | null;
  title          : string | null;
}

export function AlertDTO_EmptyObject(): AlertDTO {
  return {
    advice        : null,
    categoryID    : null,
    deleted       : null,
    endDate       : null,
    id            : '',
    impactedAreas : [],
    isActive      : null,
    isPublished   : null,
    lastUpdatedUtc: null,
    rawJson       : null,
    receivedUtc   : null,
    relations     : [],
    riskLevelID   : null,
    startDate     : null,
    takesPlace    : null,
    text          : null,
    title         : null
  };
}

export interface AlertEnvelopeDTO {
  alert: AlertDTO;
  meta : RisklineMetaDTO;
}

//#endregion

//#region Filtering (query-string params for GET /alerts)

export interface AlertFilterDTO {
  categoryIds?   : number[];
  countryIsoCode?: string;
  endDate?       : string;
  isActive?      : boolean;
  pageIndex?     : number;
  pageSize?      : number;
  riskLevelIds?  : number[];
  sortBy?        : 'lastUpdatedUtc' | 'startDate' | 'endDate' | 'title';
  sortDirection? : 'asc' | 'desc';
  startDate?     : string;
  takesPlace?    : AlertTakesPlaceDTO;
}

export interface AlertPagedResultDTO {
  items     : AlertDTO[];
  pageIndex : number;
  pageSize  : number;
  totalCount: number;
}

//#endregion
